import React, { useState, useRef } from "react";
// import { Dropdown } from "antd";
import { Menu, Dropdown, Modal, Form, Radio, Input } from "antd";
import classes from "./navTabs.module.css";
// import SubMenu from "antd/lib/menu/SubMenu";
import { MenuItem } from "rc-menu";
import { useSpreadSheet } from "../../context/spreadsheet-context";
import SubMenu from "antd/lib/menu/SubMenu";
import CreateForm from "../PivotTable/form";
import EditPivotTable from "../PivotTable/editTable";
import { EditFilled, RightOutlined } from "@ant-design/icons";
import "./menu.css";
import { findSheetName, getSelectedData } from "../../utils/helper";
import { dispatchSheetImageFileSelected } from "../../utils/spreadsheetImageHelpers";
import { loadSpreadsheetData, updateSheet } from "../../utils/api";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { useDocument } from "../../Pages/SpreadsheetContainer/documentInfoContex";
import { InsertRowBelowOutlined, InsertRowRightOutlined, PictureOutlined, TableOutlined, DeleteRowOutlined, DeleteColumnOutlined, ClearOutlined, FontSizeOutlined, FormatPainterOutlined, AppstoreOutlined } from "@ant-design/icons";

export const InsertTab = () => {
  const isMobile = window.screen.width < 769;

  // const passFunc = () => console.log('CLICKED');
  const { spreadsheetInstanceRef } = useSpreadSheet();
  const { isReadOnly } = useDocument();
  const [isVisible, setIsVisible] = useState(false);
  const [count, setCount] = useState(1);
  const [isEditPivotTable, setIsEditPivotTable] = useState(
    spreadsheetInstanceRef?.current?.sheet?.data?.pivotData?.isEdit || false);
  const fileInputRef = useRef(null);
  const { id } = useParams();

  const forInsert = (type) => {
    const { sheet } = spreadsheetInstanceRef.current;
    sheet.data.insert(type);
    sheet.table.render();
    // console.log(sheet);
  };

  const forDelete = (type) => {
    const { sheet } = spreadsheetInstanceRef.current;
    if (type === "delete-cell") {
      sheet.data.deleteCell();
      sheet.table.render();
    } else if (type === "text") {
      sheet.data.deleteCell(type);
      sheet.table.render();
    } else if (type === "format") {
      sheet.data.deleteCell(type);
      sheet.table.render();
    } else {
      sheet.data.delete(type);
      sheet.table.render();
      // console.log(sheet);
    }
  };

  const openCreateFormModal = () => {
    setIsVisible(true);
  };

  const openInsertImagePicker = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
      fileInputRef.current.click();
    }
  };

  const onInsertImageSelected = (e) => {
    const file = e.target?.files?.[0];
    if (!file || !file.type?.startsWith?.("image/")) return;
    dispatchSheetImageFileSelected(file);
  };
  const openTemplateScreen = async () => {
    const { sheet } = spreadsheetInstanceRef.current;
    const serverSheets = await loadSpreadsheetData(id);
    const liveDatas = spreadsheetInstanceRef.current?.datas || [];
    const seenNames = new Set();
    const sheetsForNaming = [];
    for (const d of liveDatas) {
      if (d?.name && !seenNames.has(d.name)) {
        seenNames.add(d.name);
        sheetsForNaming.push({ name: d.name });
      }
    }
    for (const s of Array.isArray(serverSheets) ? serverSheets : []) {
      const n = s?.name;
      if (n && !seenNames.has(n)) {
        seenNames.add(n);
        sheetsForNaming.push({ name: n });
      }
    }
    let data = getSelectedData(sheet, sheet.data.selector.range);
    let sheetName = findSheetName(sheetsForNaming, 'Template');
    const newSheetData = spreadsheetInstanceRef.current.addSheet(
      sheetName,
      true,
      true
    );
    let emails = [];
    // data.data.forEach((item) => {
    //   if (item[0].toLowerCase().includes('email')) {
    //     emails.push(item);
    //   }
    // })
    data.data.forEach((subArray) => {
      if (subArray[0].toLowerCase().includes('email')) {
        subArray.slice(1).forEach((subValue) => {
          if (subValue != '') {
            emails.push(subValue);
          }
        })
      }
    });
    const templateData = {
      ...data,
      isTemplate: true,
      emails: emails,
      editorContent: '',
      isEmailTemplate:false,
    }
    newSheetData.templateSheet = templateData;
    sheet.resetData(newSheetData, 'new');
    let payload = newSheetData.getData();
    payload.templateSheet = templateData;
    updateSheet(id, payload);
  }
  const menu = (
    <Menu className="file-menu">
      <MenuItem key="sub10" onClick={() => forInsert("row")}>
          <span className="file-menu-item"><span className="file-menu-item-left"><InsertRowBelowOutlined /></span><span className="file-menu-item-text">Insert Row</span></span>
        </MenuItem>
      <MenuItem key="sub11" onClick={() => forInsert("column")}>
          <span className="file-menu-item"><span className="file-menu-item-left"><InsertRowRightOutlined /></span><span className="file-menu-item-text">Insert Column</span></span>
        </MenuItem>
      {!isReadOnly && (
        <MenuItem key="sub-insert-image" onClick={() => openInsertImagePicker()}>
          <span className="file-menu-item"><span className="file-menu-item-left"><PictureOutlined /></span><span className="file-menu-item-text">Insert Image</span></span>
        </MenuItem>
      )}
      <MenuItem key="sub-piviot" onClick={(e) => openCreateFormModal(e)}>
          <span className="file-menu-item"><span className="file-menu-item-left"><TableOutlined /></span><span className="file-menu-item-text">Pivot table</span></span>
        </MenuItem>
      <Menu.Divider />
      <MenuItem key="sub12.2" onClick={() => forDelete("row")}>
          <span className="file-menu-item"><span className="file-menu-item-left"><DeleteRowOutlined /></span><span className="file-menu-item-text">Delete row</span></span>
        </MenuItem>
      <MenuItem key="sub12.3" onClick={() => forDelete("column")}>
          <span className="file-menu-item"><span className="file-menu-item-left"><DeleteColumnOutlined /></span><span className="file-menu-item-text">Delete column</span></span>
        </MenuItem>
      <Menu.Divider />
      <SubMenu key="sub13" popupClassName="file-menu-submenu" title={<span className="file-menu-item"><span className="file-menu-item-left"><ClearOutlined /></span><span className="file-menu-item-text">Delete with</span><span className="file-menu-item-arrow"><RightOutlined /></span></span>}>
        <MenuItem key="sub13.1" onClick={() => forDelete("text")}>
          <span className="file-menu-item"><span className="file-menu-item-left"><FontSizeOutlined /></span><span className="file-menu-item-text">Delete text</span></span>
        </MenuItem>
        <MenuItem key="sub13.2" onClick={() => forDelete("format")}>
          <span className="file-menu-item"><span className="file-menu-item-left"><FormatPainterOutlined /></span><span className="file-menu-item-text">Delete format</span></span>
        </MenuItem>
      </SubMenu>
      <MenuItem key="sub14" onClick={(e) => openTemplateScreen(e)}>
          <span className="file-menu-item"><span className="file-menu-item-left"><AppstoreOutlined /></span><span className="file-menu-item-text">Templates</span></span>
        </MenuItem>
    </Menu>
  );

  const handleEditTable = (e) => {
    e.preventDefault();
    const editIcon = document.getElementById("edit-pivot-table");
    if (editIcon) {
      editIcon.style.display = "none";
    }
    setIsEditPivotTable(true);
  }

  return (
    <>
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        style={{ display: "none" }}
        onChange={onInsertImageSelected}
      />
      <Dropdown overlay={menu} trigger={["click"]} arrow>
        <div
          className={classes.navTabButton}
          onClick={(e) => e.preventDefault()}
          style={{fontSize:isMobile?'11px':'12px'}}
        >
          Insert
        </div>
      </Dropdown>
      <span style={{ width: '0px' }}>
        {isVisible && (
          <CreateForm
            isVisible={isVisible}
            setIsVisible={setIsVisible}
            count={count}
            setCount={setCount}
            isEditPivotTable={isEditPivotTable}
            setIsEditPivotTable={setIsEditPivotTable}
          />
        )}
      </span>
      {isEditPivotTable && (
        <EditPivotTable open={isEditPivotTable} setOpen={setIsEditPivotTable} />
      )}
      <div id='edit-pivot-table' style={{ position: 'absolute', bottom: '65px', left: '45px', zIndex: '999', display: 'none' }}>
        <EditFilled style={{ fontSize: '20px' }} onClick={(e) => handleEditTable(e)} />
      </div>
    </>
  );
};
